// src/App.js
import React, { useMemo } from "react";
import Landing from "./site/Landing";

function deriveSiteIdFromHost(hostname) {
    if (!hostname) return "";

    const host = hostname.toLowerCase();

    // Local dev / IPs: don't try to infer from host
    if (host === "localhost" || host === "127.0.0.1" || host === "::1") return "";

    // Strip port if present (just in case)
    const hostNoPort = host.split(":")[0];

    // Remove common prefixes
    const cleaned = hostNoPort.startsWith("www.") ? hostNoPort.slice(4) : hostNoPort;

    // If it's a known platform domain like sites.yourdomain.com, you might want the subdomain.
    // Default behavior here: use the left-most label as siteId for multi-label domains.
    // Examples:
    //   stallingsandassociates.com -> stallingsandassociates
    //   stallingsandassociates     -> stallingsandassociates
    //   foo.bar.com                -> foo   (subdomain)
    const parts = cleaned.split(".").filter(Boolean);

    if (parts.length === 1) return parts[0]; // no TLD present (rare but possible)
    if (parts.length >= 2) {
        // If you have a platform domain like "livespheresites.com", you can special-case it here.
        // Otherwise, "stallingsandassociates.com" => "stallingsandassociates"
        return parts[0];
    }

    return "";
}

export default function App() {
    const siteId = useMemo(() => {
        // Prefer first path segment: https://host/{siteId}/...
        const path = window.location.pathname || "/";
        const seg = path.split("/").filter(Boolean)[0] || "";
        if (seg) return seg.toLowerCase();

        // Fallback to hostname-derived siteId: https://stallingsandassociates...
        return deriveSiteIdFromHost(window.location.hostname);
    }, []);

    return <Landing siteId={siteId} />;
}
